export default __webpack_public_path__ + "static/via-myetherwallet@2x-f6ea4c53ebb3142c529619f54c45bbc9.png";